module.exports = __webpack_public_path__ + "img/flamethrower-turret-gun.9c705235.png";